import { render, staticRenderFns } from "./InfoFanList.vue?vue&type=template&id=52123b44&scoped=true&"
import script from "./InfoFanList.vue?vue&type=script&lang=js&"
export * from "./InfoFanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52123b44",
  null
  
)

export default component.exports